module.exports = __webpack_public_path__ + "static/sound-6a21adb8aef73e06abb73bb5f301ed0a.png";